export default "__VITE_ASSET__5c9fc150__"